import { Stack, Text } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateOrganizationMutation } from "../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../common/auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../common/errors/useApiError";
import { TipTap } from "../../common/input/TipTap/TipTap";
import { generateHTMLFromTextDocument } from "../../common/input/TipTap/downloadTextDocument";
import { useAppDispatch } from "../../common/redux/hooks";
import { updateSelectedOrg } from "../../common/redux/reducers/authStateReducer";

export const StandardTerms = () => {
  const authState = useLoggedInWithOrgContextState();
  const [editOrg] = useUpdateOrganizationMutation();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const displayer = useApiError();
  const [initialContent] = useState<string>(authState.selectedOrg.standardTerms ?? "");

  const save = async (value: string) => {
    try {
      const data = await editOrg({
        orgId: authState.selectedOrg.id,
        editOrganizationRequest: { standardTerms: { value: generateHTMLFromTextDocument(value) } },
      }).unwrap();
      dispatch(updateSelectedOrg(data));
    } catch (e) {
      displayer.trigger(e);
    }
  };

  return (
    <Stack spacing="3">
      <Text fontWeight="medium">{t("Standard terms")}</Text>
      <Text fontSize="sm" color="smMuted">
        {t("These terms must be read and accepted by suppliers before they can submit a bid in any procurement.")}
      </Text>
      <TipTap content={initialContent} onUpdate={save} />
    </Stack>
  );
};
